var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-table",
    {
      directives: [{ name: "sticky-header", rawName: "v-sticky-header" }],
      attrs: {
        stripe: "",
        fit: "",
        "highlight-current-row": "",
        data: _vm.list,
        "header-cell-class-name": "table-header-cell",
      },
    },
    [
      _c("el-table-column", {
        attrs: {
          label: "订单号",
          prop: "orderNumber",
          width: "120",
          align: "center",
          fixed: _vm.device !== "mobile",
        },
      }),
      _vm.isRefund
        ? [
            _c("el-table-column", {
              attrs: {
                label: "退款单号",
                prop: "refundNumber",
                width: "120",
                align: "center",
              },
            }),
            _c("el-table-column", {
              attrs: {
                label: "退款时间",
                prop: "refundTime",
                width: "100",
                align: "center",
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c("div", [
                          _vm._v(_vm._s(_vm._f("filterDate")(row.refundTime))),
                        ]),
                        _c("div", [
                          _vm._v(_vm._s(_vm._f("filterTime")(row.refundTime))),
                        ]),
                      ]
                    },
                  },
                ],
                null,
                false,
                261813843
              ),
            }),
          ]
        : _vm._e(),
      _c("el-table-column", {
        attrs: {
          label: "支付单号",
          prop: "payNumber",
          width: "120",
          align: "center",
        },
      }),
      _c("el-table-column", {
        attrs: {
          label: "下单时间",
          prop: "orderTime",
          width: "100",
          align: "center",
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function ({ row }) {
              return [
                _c("div", [
                  _vm._v(_vm._s(_vm._f("filterDate")(row.orderTime))),
                ]),
                _c("div", [
                  _vm._v(_vm._s(_vm._f("filterTime")(row.orderTime))),
                ]),
              ]
            },
          },
        ]),
      }),
      _c("el-table-column", {
        attrs: { label: "用户信息", "min-width": "150" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function ({ row }) {
              return [
                _c("div", [
                  _c("span", { staticClass: "bold" }, [_vm._v("编号：")]),
                  _vm._v(_vm._s(row.shareCode)),
                ]),
                _c("div", [
                  _c("span", { staticClass: "bold" }, [_vm._v("昵称：")]),
                  _vm._v(_vm._s(row.nickName)),
                ]),
                _c("div", [
                  _c("span", { staticClass: "bold" }, [_vm._v("手机：")]),
                  _vm._v(_vm._s(row.mobile)),
                ]),
              ]
            },
          },
        ]),
      }),
      _c("el-table-column", {
        attrs: { label: "商品信息", "min-width": "250" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function ({ row }) {
              return _vm._l(row.products, function (item, pid) {
                return _c(
                  "div",
                  { key: pid, staticClass: "flex align-start just-between" },
                  [
                    _c("el-image", {
                      staticClass: "product-cover",
                      attrs: {
                        src: item.cover,
                        "preview-src-list": [item.cover],
                        lazy: "",
                      },
                    }),
                    _c("div", { staticClass: "flex-sub" }, [
                      _vm._v(_vm._s(item.goodsName)),
                    ]),
                    _c("div", { staticClass: "sku-count" }, [
                      _vm._v(_vm._s(`x${item.skuCount}`)),
                    ]),
                  ],
                  1
                )
              })
            },
          },
        ]),
      }),
      !_vm.isRefund
        ? [
            _c("el-table-column", {
              attrs: {
                label: "配送方式",
                prop: "deliveryMethodName",
                width: "80",
                align: "center",
              },
            }),
            _vm.isLocal
              ? _c("el-table-column", {
                  attrs: { label: "商家信息", "min-width": "200" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _c("div", [
                              _c("span", { staticClass: "bold" }, [
                                _vm._v(_vm._s(row.consigneeName)),
                              ]),
                            ]),
                            _c("div", [_vm._v(_vm._s(row.consigneeMobile))]),
                            _c("div", [
                              _vm._v(
                                _vm._s(
                                  `${row.consigneeRegion} ${row.consigneeAddress}`
                                )
                              ),
                            ]),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    1443716326
                  ),
                })
              : _c("el-table-column", {
                  attrs: { label: "收货信息", "min-width": "200" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function ({ row }) {
                          return [
                            _c("div", [
                              _c("span", { staticClass: "bold" }, [
                                _vm._v(_vm._s(row.consigneeName)),
                              ]),
                              _c("span", { staticClass: "pl-10" }, [
                                _vm._v(_vm._s(row.consigneeMobile)),
                              ]),
                            ]),
                            _c("div", [
                              _vm._v(
                                _vm._s(
                                  `${row.consigneeRegion}${row.consigneeAddress}`
                                )
                              ),
                            ]),
                            row.logisticsName
                              ? _c("div", { staticClass: "mt-5" }, [
                                  _c("span", { staticClass: "bold" }, [
                                    _vm._v("快递公司："),
                                  ]),
                                  _vm._v(_vm._s(row.logisticsName)),
                                ])
                              : _vm._e(),
                            row.logisticsNumber
                              ? _c("div", [
                                  _c("span", { staticClass: "bold" }, [
                                    _vm._v("快递单号："),
                                  ]),
                                  _vm._v(_vm._s(row.logisticsNumber)),
                                ])
                              : _vm._e(),
                            row.logisticsTime
                              ? _c("div", [
                                  _c("span", { staticClass: "bold" }, [
                                    _vm._v("发货时间："),
                                  ]),
                                  _vm._v(_vm._s(row.logisticsTime)),
                                ])
                              : _vm._e(),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    1887610078
                  ),
                }),
          ]
        : _vm._e(),
      _c("el-table-column", {
        attrs: {
          label: "订单金额",
          prop: "orderPrice",
          "min-width": "90",
          align: "right",
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function ({ row }) {
              return [
                row.orderType === 72000
                  ? [
                      _c("div", { staticClass: "space-nowrap" }, [
                        _c("span", { staticClass: "bold" }, [
                          _vm._v("总金额："),
                        ]),
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm._f("filterInteger")(row.orderPrice))
                          ),
                        ]),
                      ]),
                      _c("div", { staticClass: "space-nowrap" }, [
                        _c("span", { staticClass: "bold" }, [_vm._v("积分：")]),
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm._f("filterInteger")(row.orderPoint))
                          ),
                        ]),
                      ]),
                      _c("div", { staticClass: "space-nowrap" }, [
                        _c("span", { staticClass: "bold" }, [_vm._v("券：")]),
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm._f("filterInteger")(row.orderCoupon))
                          ),
                        ]),
                      ]),
                    ]
                  : row.orderType === 73000
                  ? [
                      _c("span", { staticClass: "bold" }, [_vm._v("积分：")]),
                      _vm._v(
                        _vm._s(_vm._f("filterInteger")(row.orderPoint)) + " "
                      ),
                    ]
                  : row.orderType === 75000
                  ? [
                      _c("div", { staticClass: "space-nowrap" }, [
                        _c("span", { staticClass: "bold" }, [_vm._v("现金：")]),
                        _c("span", [
                          _vm._v(_vm._s(_vm._f("filterPrice")(row.orderPrice))),
                        ]),
                      ]),
                      parseFloat(row.orderPoint) > 0
                        ? _c("div", { staticClass: "space-nowrap" }, [
                            _c("span", { staticClass: "bold" }, [
                              _vm._v("积分："),
                            ]),
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm._f("filterPrice")(row.orderPoint))
                              ),
                            ]),
                          ])
                        : _vm._e(),
                      parseFloat(row.orderCoupon) > 0
                        ? _c("div", { staticClass: "space-nowrap" }, [
                            _c("span", { staticClass: "bold" }, [
                              _vm._v("券："),
                            ]),
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm._f("filterPrice")(row.orderCoupon))
                              ),
                            ]),
                          ])
                        : _vm._e(),
                    ]
                  : row.orderType === 76000
                  ? [
                      _c("div", { staticClass: "space-nowrap" }, [
                        _c("span", { staticClass: "bold" }, [_vm._v("积分：")]),
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm._f("filterInteger")(row.orderPoint))
                          ),
                        ]),
                      ]),
                      _c("div", { staticClass: "space-nowrap" }, [
                        _c("span", { staticClass: "bold" }, [_vm._v("券：")]),
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm._f("filterInteger")(row.orderCoupon))
                          ),
                        ]),
                      ]),
                    ]
                  : row.orderType === 77000
                  ? [
                      row.payMethod === 0
                        ? [
                            _c("span", { staticClass: "bold" }, [
                              _vm._v("积分："),
                            ]),
                            _vm._v(
                              _vm._s(_vm._f("filterInteger")(row.orderPoint)) +
                                " "
                            ),
                          ]
                        : [
                            _c("div", { staticClass: "space-nowrap" }, [
                              _c("span", { staticClass: "bold" }, [
                                _vm._v("现金："),
                              ]),
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm._f("filterPrice")(row.orderPrice))
                                ),
                              ]),
                            ]),
                            row.payMethod === 2
                              ? _c("div", { staticClass: "space-nowrap" }, [
                                  _c("span", { staticClass: "bold" }, [
                                    _vm._v("积分："),
                                  ]),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("filterPrice")(row.orderPoint)
                                      )
                                    ),
                                  ]),
                                ])
                              : _vm._e(),
                          ],
                    ]
                  : _vm._e(),
              ]
            },
          },
        ]),
      }),
      _c("el-table-column", {
        attrs: {
          label: "状态",
          prop: "orderStatusName",
          width: "80",
          align: "center",
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function ({ row }) {
              return [
                _vm.isRefund
                  ? [
                      row.refundStatus === 4
                        ? _c(
                            "el-tag",
                            {
                              attrs: {
                                type: "info",
                                size: "medium",
                                effect: "dark",
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.getRefundStatus(row.refundStatus))
                              ),
                            ]
                          )
                        : row.refundStatus === 3
                        ? _c(
                            "el-tag",
                            {
                              attrs: {
                                type: "success",
                                size: "medium",
                                effect: "dark",
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.getRefundStatus(row.refundStatus))
                              ),
                            ]
                          )
                        : row.refundStatus === 2
                        ? _c(
                            "el-tag",
                            {
                              attrs: {
                                type: "warning",
                                size: "medium",
                                effect: "dark",
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.getRefundStatus(row.refundStatus))
                              ),
                            ]
                          )
                        : row.refundStatus === 1
                        ? _c(
                            "el-tag",
                            {
                              attrs: {
                                type: "danger",
                                size: "medium",
                                effect: "dark",
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.getRefundStatus(row.refundStatus))
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]
                  : [
                      row.orderStatus >= 51
                        ? _c(
                            "el-tag",
                            {
                              attrs: {
                                type: "success",
                                size: "medium",
                                effect: "dark",
                              },
                            },
                            [_vm._v(_vm._s(row.orderStatusName))]
                          )
                        : row.orderStatus === 13
                        ? _c(
                            "el-tag",
                            {
                              attrs: {
                                type: "info",
                                size: "medium",
                                effect: "dark",
                              },
                            },
                            [_vm._v(_vm._s(row.orderStatusName))]
                          )
                        : row.orderStatus === 41
                        ? _c(
                            "el-tag",
                            {
                              attrs: {
                                type: "warning",
                                size: "medium",
                                effect: "dark",
                              },
                            },
                            [_vm._v(_vm._s(row.orderStatusName))]
                          )
                        : row.orderStatus === 21
                        ? _c(
                            "el-tag",
                            {
                              attrs: {
                                type: "danger",
                                size: "medium",
                                effect: "plain",
                              },
                            },
                            [_vm._v(_vm._s(row.orderStatusName))]
                          )
                        : _c(
                            "el-tag",
                            { attrs: { size: "medium", effect: "dark" } },
                            [_vm._v(_vm._s(row.orderStatusName))]
                          ),
                    ],
              ]
            },
          },
        ]),
      }),
      _c("el-table-column", {
        attrs: { align: "center", width: "80", fixed: "right" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function ({ row }) {
              return [
                _c(
                  "el-dropdown",
                  { attrs: { trigger: "click", szie: "medium" } },
                  [
                    _c("span", { staticClass: "el-dropdown-link" }, [
                      _vm._v(" 操作"),
                      _c("i", {
                        staticClass: "el-icon-arrow-down el-icon--right",
                      }),
                    ]),
                    _c(
                      "el-dropdown-menu",
                      { attrs: { slot: "dropdown" }, slot: "dropdown" },
                      [
                        _vm.isRefund
                          ? [
                              _c(
                                "el-dropdown-item",
                                {
                                  attrs: {
                                    icon: "el-icon-refresh-left",
                                    disabled: row.refundStatus > 1,
                                  },
                                  nativeOn: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.handleVerify(row)
                                    },
                                  },
                                },
                                [_vm._v("退货退款")]
                              ),
                            ]
                          : [
                              row.deliveryMethod === 1
                                ? _c(
                                    "el-dropdown-item",
                                    {
                                      attrs: {
                                        icon: "el-icon-finished",
                                        disabled: !!row.logisticsTime,
                                      },
                                      nativeOn: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          return _vm.handleVerify(row)
                                        },
                                      },
                                    },
                                    [_vm._v("订单核销")]
                                  )
                                : _vm._e(),
                              row.deliveryMethod === 2
                                ? [
                                    _c(
                                      "el-dropdown-item",
                                      {
                                        attrs: {
                                          disabled: row.orderStatus !== 21,
                                          icon: "el-icon-upload",
                                        },
                                        nativeOn: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            return _vm.handleShipping(row)
                                          },
                                        },
                                      },
                                      [_vm._v("订单发货")]
                                    ),
                                    _c(
                                      "el-dropdown-item",
                                      {
                                        attrs: {
                                          disabled: row.orderStatus !== 21,
                                          icon: "el-icon-shopping-bag-2",
                                          divided: "",
                                        },
                                        nativeOn: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            return _vm.handlePickup(row)
                                          },
                                        },
                                      },
                                      [_vm._v("设置自提")]
                                    ),
                                  ]
                                : _vm._e(),
                              [71000, 72000, 75000, 77000].includes(
                                row.orderType
                              )
                                ? [
                                    _c(
                                      "el-dropdown-item",
                                      {
                                        attrs: {
                                          divided: "",
                                          icon: "el-icon-money",
                                        },
                                        nativeOn: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            return _vm.handleRefund(row)
                                          },
                                        },
                                      },
                                      [_vm._v("退货退款")]
                                    ),
                                  ]
                                : _vm._e(),
                            ],
                        _c(
                          "el-dropdown-item",
                          {
                            attrs: { divided: "", icon: "el-icon-document" },
                            nativeOn: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.handleDetail(row)
                              },
                            },
                          },
                          [_vm._v("订单详情")]
                        ),
                        _c(
                          "el-dropdown-item",
                          {
                            attrs: { icon: "el-icon-camera" },
                            nativeOn: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.handleRecord(row)
                              },
                            },
                          },
                          [_vm._v("操作记录")]
                        ),
                      ],
                      2
                    ),
                  ],
                  1
                ),
              ]
            },
          },
        ]),
      }),
      _vm.showDelivery
        ? _c("order-delivery", {
            attrs: { show: _vm.showDelivery, order: _vm.orderInfo },
            on: {
              "update:show": function ($event) {
                _vm.showDelivery = $event
              },
              "update:order": function ($event) {
                _vm.orderInfo = $event
              },
              refresh: _vm.shipmentRefresh,
            },
          })
        : _vm._e(),
      _vm.showRefund
        ? _c("order-refund", {
            attrs: { show: _vm.showRefund, order: _vm.orderInfo },
            on: {
              "update:show": function ($event) {
                _vm.showRefund = $event
              },
              "update:order": function ($event) {
                _vm.orderInfo = $event
              },
              refresh: _vm.refundRefresh,
            },
          })
        : _vm._e(),
      _vm.showDetail
        ? _c("order-detail", {
            attrs: { show: _vm.showDetail, order: _vm.orderInfo },
            on: {
              "update:show": function ($event) {
                _vm.showDetail = $event
              },
            },
          })
        : _vm._e(),
      _vm.showLog
        ? _c("order-log", {
            attrs: { show: _vm.showLog, "order-id": _vm.orderInfo.id },
            on: {
              "update:show": function ($event) {
                _vm.showLog = $event
              },
            },
          })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }